// useHotLeads.js
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import LeadDbService from "../components/Services/LeadDbService";
import LocationService from "../components/Services/LocationService";
import teamService from "../components/Services/TeamService";
import { leadStatusMap } from "../components/Constant/Constant";
import {
  showErrorToast,
  showSuccessToast,
} from "../components/Constant/Notification";
import HotLeadService from "../components/Services/HotLeadService";
import { getBasePathByUserRole } from "../utils/roleRoutes";

const useHotLeads = () => {
  const [leads, setLeads] = useState([]);

  const [filterVisible, setFilterVisible] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [interestLocationTags, setInterestedLocationTags] = useState([]);
  const [optionLocation, setOptionLocation] = useState([]);
  const [teams, setTeams] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [selectedCountLead, setSelectedCountLead] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [nextPageToken, setNextPageToken] = useState(null);
  const [prevPageToken, setPrevPageToken] = useState(null);
  const [hasMoreLeads, setHasMoreLeads] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [leadCache, setLeadCache] = useState({});
  const [lastUpdateLeadData, setLastUpdateLeadData] = useState();
  const [nextUpdateLeadData, setNextUpdateLeadData] = useState();
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("userData"));
  const userRole = userData?.user?.role;
  const teamIds = userData?.teamId || [];

  const [isOpen, setIsOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState(null);
  const [selectedLead, setSelectedLead] = useState(null);
  const [leadAssignStatus, setLeadAssignStatus] = useState(null);
  const [hotLeadCount, setHotLeadCount] = useState(0);

  const [leadHotHistotyData, setLeadHotHistotyData] = useState([]);

  const menuRef = useRef(null);

  const formatDate = (date) => {
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const year = d.getFullYear();
    return `${month}-${day}-${year}`;
  };

  const formattedStartDate = startDate ? formatDate(startDate) : "";
  const formattedEndDate = endDate ? formatDate(endDate) : "";

  const getLead = async (
    pageToken = null,
    direction = "next",
    limitOverride = null,
    overridePage = null,
    forceReload = false,
    selectedCountLead,
  ) => {
    const targetPage = overridePage ?? currentPage;

    if (startDate && !endDate) {
      showErrorToast("End Date is required when Start Date is selected.");
      return;
    }

    if (!forceReload && leadCache[targetPage]) {
      const cached = leadCache[targetPage];
      setLeads(cached.leads);
      setNextPageToken(cached.next);
      setPrevPageToken(cached.prev);
      setHasMoreLeads(!!cached.next);
      setCurrentPage(targetPage);
      return;
    }

    setLoading(true);

    try {
      const body = {
        count: selectedCountLead || null,
        startDate: formattedStartDate || null,
        endDate: formattedEndDate || null,
        limit: limitOverride ?? pageSize,
        next: direction === "next" ? pageToken : null,
        previous: direction === "previous" ? pageToken : null,
        direction,
      };

      const response = await HotLeadService.getHotLeadsList(body);
      const newLeads = response.data.leads;
      const newNext = response.data.next;
      const newPrev = response.data.prev;

      setLeadCache((prev) => ({
        ...prev,
        [targetPage]: { leads: newLeads, next: newNext, prev: newPrev },
      }));

      setLeads(newLeads);
      setNextPageToken(newNext);
      setPrevPageToken(newPrev); /// 10 >= 9  
      setHasMoreLeads(!!newNext);
      setCurrentPage(targetPage);
    } catch (error) {
      console.error("Error in getLead:", error);
    } finally {
      setLoading(false);
    }
  };

  const applyFilter = () => {
    setLeadCache({});
    setCurrentPage(1);
    
    getLead(null, "reset", pageSize, 1, true , selectedCountLead);
    setFilterVisible(false);
  };

  const clearFilterData = () => {
   setSelectedCountLead(0)

    setStartDate("");
    setEndDate("");
    getLead(null, "reset", pageSize, 1, true , null);
    setFilterVisible(false)
    
  };

  const handlePageChange = (tokenOrValue, direction) => {
    console.log("Token or Value:", tokenOrValue);

    if (direction === "size") {
      const newPageSize = parseInt(tokenOrValue, 10);
      setPageSize(newPageSize);
      setCurrentPage(1);
      setLeadCache({});
      setNextPageToken(null);
      setPrevPageToken(null);
      getLead(null, "reset", newPageSize, 1 , true , selectedCountLead);
    } else if (direction === "next") {
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage);
      getLead(nextPageToken, "next", pageSize, nextPage , true , selectedCountLead);
    } else if (direction === "previous") {
      const prevPage = Math.max(currentPage - 1, 1);
      setCurrentPage(prevPage);
      getLead(prevPageToken, "previous", pageSize, prevPage ); ;
    }
  };

  const handleSearchLead = () => {
    setLeadCache({});
    setCurrentPage(1);
    getLead(null, "reset", pageSize, 1, true , selectedCountLead);
  };

  const path = getBasePathByUserRole();

  const handleLeadInfo = (lead) => {
    const pathRoute = `${path}/lead-info/${lead?.id}`;
    navigate(pathRoute, { state: { lead } });
  };

  useEffect(() => {
    getLead(null, "reset", pageSize, 1, true , selectedCountLead);
  }, [pageSize]);

  // const handleHotLeadCount = async () => {
  //   try {
  //     const hotLeadCount = await HotLeadService.getHotLeadCount();

  //     setHotLeadCount(hotLeadCount.data?.count);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const handleLeadHotHistory = async (leadId) => {
    setIsOpen(true);
    try {
      const response = await HotLeadService.getHotLeadHistory(leadId);
      if (response.status === 200) {
        const data = response.data?.history;
        setLeadHotHistotyData(data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleLeadHotHistoryDelete = async (leadId) => {
    try {
      const body = {
        docId: leadId,
      };

      const response = await HotLeadService.cancelHotLeads(body);
      
      if (response.status === 200) {
        showSuccessToast(response?.data);
        getHotLeadCount()
        getLead(null, "reset", pageSize, 1, true , selectedCountLead);
        setIsModalOpen(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleHotLeadClick = (lead) => {
    setSelectedLeadId(lead.id);
    setSelectedLead(lead);

    if (!lead.assignedTeamName || !lead.assignedUserName) {
     
      setLeadAssignStatus(true);
      setIsModalOpen2(true);
    } 
    else {
      setLeadAssignStatus(false);
      setIsModalOpen2(true);
    }
  };

  const handleHotLeadSend = async (leadId) => {
    if (leadAssignStatus) {
      
      // navigate(`${path}/lead/reassign`, {
      //   state: {
      //     assignStatus: true,
      //     leadCount: 1,
      //     teamId: selectedLead?.teamName,
      //     leadId: leadId,
      //   },
      // });

      setIsModalOpen2(false)
    
    } else {
      try {
        const body = {
          docId: leadId,
        };
        const response = await HotLeadService.convertHotLeads(body);
        if (response.status === 200) {
          showSuccessToast(response?.data);
          getHotLeadCount()
          getLead(null, "reset", pageSize, 1, true , selectedCountLead);
          setIsModalOpen2(false);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const getHotLeadCount = async () =>{
    try {
      const hotLeadCount = await HotLeadService.getHotLeadCount();

      setHotLeadCount(hotLeadCount.data?.count);

    }catch(error){
      console.log(error)
    }
  }
  useEffect(()=>{
    getHotLeadCount();
  },[])

  return {
    leads,
    filterVisible,
    setFilterVisible,
    selectedStatus,
    setSelectedStatus,
    selectedLevel,
    setSelectedLevel,
    interestLocationTags,
    setInterestedLocationTags,
    optionLocation,
    teams,
    users,
    selectedUser,
    setSelectedUser,
    selectedRows,
    setSelectedRows,
    selectedTeam,
    setSelectedTeam,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    searchQuery,
    setSearchQuery,
    selectedCountLead,
    setSelectedCountLead,
    isOpen,
    setIsOpen,
    isModalOpen,
    setIsModalOpen,
    isModalOpen2,
    setIsModalOpen2,
    selectedLeadId,
    setSelectedLeadId,
    setLeadAssignStatus,
    leadAssignStatus,
    leadHotHistotyData,
    setLeadHotHistotyData,
    loading,
    isLoading,
    currentPage,
    nextPageToken,
    prevPageToken,
    hasMoreLeads,
    pageSize,
    lastUpdateLeadData,
    nextUpdateLeadData,
    menuRef,
    userRole,
    applyFilter,
    clearFilterData,
    handlePageChange,
    handleSearchLead,
    handleLeadInfo,
    handleLeadHotHistory,
    handleLeadHotHistoryDelete,
    handleHotLeadSend,
    handleHotLeadClick,
    // handleHotLeadCount,
    hotLeadCount,
  };
};

export default useHotLeads;
